export const i18nEventPage = {
  alarm: 'Alarma',
  alarm_and_period: 'Alarma + periodo de riesgo',
  closed_alarm: 'Alarma fechada',
  expand: 'Expandir lista',
  expand_tutorial_title: 'Presentando Insights Visuales',
  expand_tutorial_description:
    'Tu lista de alarmas ahora incluye gráficos para obtener insights rápidos. Usa "Expandir Lista" para volver a la vista completa de la lista.',
  expand_tutorial_button: 'Entendido',
  show_analytics: 'Mostrar Analytics',
  grid: {
    ack_status: 'Estado de Reconocimiento',
    alarms: 'Alarmes',
    acked: 'Reconocidos',
    new: 'Nuevo',
  },
  analytics: {
    bar_chart_title: 'Alarmes por período',
    day: 'Diario',
    week: 'Semanal',
    month: 'Mensual',
    year: 'Anual',
    hour: 'Por hora',
  },
  automatic_ack_info: {
    text: '<strong>{{models}} modelos</strong> están configurados con auto-reconocimiento. <strong>{{alarms}} alarmas</strong> fueron reconocidas automáticamente en el período seleccionado.',
    view_models: 'Ver modelos',
    view_alarms: 'Ver Alarmes',
  },
  automatic_ack_models: {
    title: 'Modelos con auto-reconocimiento habilitado',
  },
  sections: {
    prediction_graph: 'Modelo de riesgo de falla',
    pump_curve: 'Curva de rendimiento de la bomba',
    sensors_graph: 'Datos del sensor',
    analysis: 'Análisis',
    history: 'Histórico',
    event_list: 'Últimos eventos {{asset}}',
    flat_line_graph: 'Línea plana',
    diagnostic: 'Diagnóstico',
    recommendation: 'Recomendaciones',
  },
  charts_tabs: {
    features: 'Features',
    feature: 'Features',
    sujidade: 'Suciedad',
    sensors: 'Sensores',
    sensor: 'Sensores',
    amoeba: 'Vista de gráfico',
    plot: 'Vista de gráfico',
    radar: 'Vista de radar',
    risk: 'Puntuación de Riesgo',
  },
  event: {
    sections: {
      details: 'Detalles',
      prognosis: 'Pronóstico',
      radar: 'Vista de radar',
      amoeba: 'Vista de gráfico',
      sensors: 'Sensores',
      sensor: 'Sensores',
      risk: 'Puntuación de Riesgo',
    },
  },
  components: {
    relatedTables: {
      events: 'Alarmas Similares',
      condition_deviations: 'Desviaciones de Condición',
      sap_notes: 'Notas de Mant.',
      cases: 'Casos',
    },
    similarEvents: {
      no_data: 'No hay registro de un evento similar reconocido en el último año',
      text: 'Evento similar detectado el {{eventDate}} - {{useful}} {{eventComments}} ',
      button: 'Abrir',
    },
    similarEventsList: {
      title: 'Últimas apariciones de esta alarma',
      btn: 'Alarmas Similares',
      empty_message: 'No hay alarmas para este activo en el período seleccionado.',
    },
    eventFooter: {
      btns: {
        maintenance: 'Mantenimiento',
        assetPage: 'Activo page',
        cds: 'Desv. de Cond.',
        Records: 'Registros',
        cases: 'Casos',
      },
    },
    maintenanceModal: 'Notas de Mantenimiento',
    modalAck: {
      title: { OPEN: 'Reconocer esta alarma', CLOSED: 'Reclasificar esta alarma' },
      labels: {
        classification: 'Clasificación',
        why_not_useful: '¿Por qué no es útil?',
        comments: 'Comentarios',
        willAssociateCD:
          '¿Hay una necesidad que deba ser abordada por una Desviación de Condición?',
        next_step: 'Próximo paso',
        NO_ACTION: 'Sin acción',
        ATTACH_ALARM_TO_AN_EXISTING_CASE_TITLE: 'Adjuntar alarma a un caso existente',
        ATTACH_ALARM_TO_AN_EXISTING_CASE:
          'Adjuntar alarma a un caso existente ({{quantity}} abierto)',
        CREATE_NEW_CASE_AND_ATTACH_ALARM: 'Crear nuevo caso y adjuntar alarma',
      },

      btns: {
        ack: 'Reconocer',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
      },
      placeholders: {
        comments: 'Por favor, comparta cualquier información relevante sobre esta alarma',
        select_an_option: 'Seleccione una opción',
      },

      required_field: 'Campo requerido',
    },
    btns: {
      PI: 'Ir a PI',
      Expand: 'Expandir',
    },
    conditions_related: {
      viewCds: 'Ver desviaciones de condición del activo',
      newCd: 'Abrir nueva desviación de condición',
      fullCdPage: 'Página completa de desviación de condición',
    },

    event_summary: {
      start_time: 'Inicio',
      end_time: 'Fin',
      asset_name: 'Equipo',
      description: 'Descripción del evento',
      status: 'Estado',
      classification: 'Clasificación',
      model: 'Modelo',
      id: 'ID del evento',
      alarms_count: 'Alarmas',
    },
    analysis: {
      fields: {
        status: 'Estado',
        classification: 'Clasificación',
        action: 'Acción del operador',
        work_order: 'Orden de servicio (número)',
        reason: 'Razón',
        failure_occurred: '¿Hubo falla?',
        additional_info: 'Informaciones adicionales',
        end_date: 'Estimación para completar la investigación',
      },
      actions: {
        attach: 'Adjuntar archivo',
        save: 'Guardar',
        attachments: 'Adjuntos',
        required_field: 'Campo obligatorio',
        max_length: 'Longitud máxima de {{size}} caracteres',
      },
    },
    history: {
      comment_placeholder: 'Agregar comentarios',
      empty_history: 'Evento sin historial de cambios',
      item: {
        template: {
          action: { insert: 'añadió', update: 'actualizó', delete: 'eliminó', attach: 'adjuntó' },
          title: '{{author}} {{action}} {{attribute}}',
          message: { text: '{{text}}', from_to: 'De {{previous}} para {{current}}' },
        },
      },
    },
    sensors_graphic: {
      variables_contribution: 'Contribución de las variables',
      all_sensors: 'Todos los sensores',
      all_features: 'Todos las features',
    },
    alarmsByAlgorithmTable: {
      name: 'Modelos',
      bar: 'Alarmas',
      count: '#',
      dataOptions: {
        models: 'Modelos',
        assets: 'Activos',
      },
    },
  },
  message: {
    no_data: {
      message: 'No hay alarmas en el período y los filtros seleccionados',
    },
    generic_error: {
      title: 'Ops..',
      message: 'Ha ocurrido un error inesperado. Espera unos minutos e inténtalo de nuevo',
    },
    inexistent_event: {
      title: 'Evento no encontrado',
      message: 'Intente con una identificación de evento válido',
    },
    analysis_submit: {
      success: { title: 'Éxito', message: 'Análisis enviado' },
      error: { title: 'Error', message: 'No se pudo enviar el análisis' },
    },
    features_contribution_error: {
      title: 'Ops..',
      message: 'Error al cargar datos de contribución por feature',
    },
    empty_historic: { title: 'Histórico vacío', message: 'No hay cambios para este Evento' },
    historic_error: {
      title: 'Error al cargar histórico',
      message: 'Vuelve a intentarlo más tarde',
    },
    comment_submit: {
      success: { title: 'Éxito', message: 'Comentario enviado' },
      error: { title: 'Error', message: 'No se pudo enviar comentario' },
    },
  },
  severity: {
    very_high: 'Muy alta',
    high: 'Alta',
    medium: 'Media',
    low: 'Baja',
    Information: 'Baja',
    Warning: 'Baja',
    Minor: 'Medium',
    Major: 'Alta',
    Critical: 'Muy alta',
  },
  no_data: 'Datos no disponibles',
  status: { open: 'Nuevo', closed: 'Reconocido', total: 'Total por período' },
  no_prognosis: 'Nenhum prognóstico disponível para este evento',
  main_tabs: { OPEN: 'Nuevo', CLOSED: 'Admitido', ALL: 'Todos' },
  event_details: {
    severity: 'Severidad',
    alarm_datetime_start: 'Inicio',
    alarm_datetime_end: 'Fin',
    duration: 'Duración',
    method: 'Método',
    category: 'Categoría',
    vessel: 'Navío',
    system: 'Sistema',
    subsystem: 'Subsistema',
    asset: 'Activo',
  },

  useful_modal: {
    withCds: {
      title: 'Alarma reconocida. ¿Verificar desviaciones de condición del activo?',
      text: 'La alarma se ha guardado como útil. ¿Desea verificar si hay una desviación de condición abierta para investigar este problema?',
      action: 'Sí, verificar desviaciones de condición del activo',
      cancelBtn: 'No, gracias',
    },
    withoutCds: {
      title: 'Alarma guardada. ¿Abrir nueva Desviación de Condición?',
      text: 'La alarma se ha guardado como Útil. ¿Desea abrir una nueva Desviación de Condición para investigar el problema?',
      action: 'Sí, abrir CD',
      cancelBtn: 'No abrir',
    },
  },

  tag: { alarms: 'Alarmas', aggregated: 'Agregado' },
  filters: {
    all_assets: 'Todos los activos',
    all_categories: 'Todas las categorías',
    search: 'Buscar',
  },
  status_count_panel: {
    empty_data: 'No hay datos disponibles para filtrar',
    total: { caption: 'Alarmas' },
    severity: {
      title: 'Severidad',
      4: 'Muy Alta',
      3: 'Alta',
      2: 'Media',
      1: 'Baja',
    },
    status: {
      total: { title: 'Total', total: 'Alarmas' },
      status: { title: 'Estado', OPEN: 'Abierto', CLOSED: 'Cerrado' },
      classification: { title: 'Clasificación', USEFUL: 'Útil', NOT_USEFUL: 'No Útil' },
    },
  },
  table: {
    severity_status: 'Severidad',
    description: 'Nombre',
    vessel: 'Navío',
    system: 'Sistema',
    subsystem: 'Subsistema',
    asset: 'Equipo',
    alarm_datetime_start: 'Inicio',
    duration: 'Duración',
    classification: 'Clasific.',
    closed_by: 'Cerrado por',
    records: 'Registros',
    status: 'Estado',
    agreg: '#',
    link: '',
    id: 'ID',
    checkbox: '',
    see_event: 'Ver evento',
    model_label: 'Modelo',
    case_name: 'Caso',
    number_of_alarms: 'Alarmas (periodo)',
    asset_name: 'Activo',
  },
  change_status_form: {
    status: 'Estado',
    classification: 'Clasificación',
    why_not_useful: '¿Por qué no es útil?',
    select_an_option: 'Seleccione una opción',
    save: 'Guardar',
    required_field: 'Campo requerido',
  },
  expanded_charts: {
    tabs: {
      alarm_related_charts: 'Gráficos relacionados con alarmas',
      equipment_sensors: 'Sensores de equipos',
    },
  },
  chart_status: {
    status: { OPEN: 'Abierto', CLOSED: 'Cerrado' },
    classification: { USEFUL: 'Útil', NOT_USEFUL: 'No Útil' },

    whyNotUseful: {
      PROCESS_INSTABILITY: 'Inestabilidad del proceso',
      PRODUCTION_RESTART: 'Reinicio de la producción',
      INSTRUMENT_ERROR: 'Error del instrumento',
      PROCESS_CHANGE: 'Cambio en el proceso',
      TESTS_IN_PROGRESS: 'Pruebas en curso',
      INAPPROPRIATE_LIMITS: 'Límites inadecuados',
      UNCALIBRATED_MODEL: 'Modelo no calibrado',
      THERE_IS_NO_CERTAINTY: 'No hay certeza',
      THERE_IS_NO_CERTAINITY: 'No hay certeza',
      OTHERS: 'Otro',
      OTHER: 'Otro',
      CHANGE_OF_OPERATING_LEVEL: 'Cambiar de nivel de operación',
      EQUIPMENT_START_STOP: 'Equipo Inicio/parada',
      SPURIOUS_ALARM: 'Alarma espuria',
      MACHINE_IS_OFF: 'Equipo is off',
      USEFUL: 'Útil',
      NOT_USEFUL: 'No Útil',
    },
  },
  snackbarMessages: {
    success: {
      title: 'Éxito',
      message: 'Evento actualizado con Éxito',
    },
    error: {
      title: 'Error',
      message: 'Error al actualizar evento',
      upload: 'Error al cargar el archivo',
      file_size: 'El archivo es más grande que el tamaño permitido',
      file_extension: 'El archivo no está en los formatos permitidos',
    },
  },
};
